import * as firebaseCore from './firebase_core';
import store from '../stores';

// let dbValue = null;

export const linktoDB = (uid) => {
  const ref = firebaseCore.database.ref(`/users/${uid}`);
  ref.once('value')
    .then((snap) => {
      snap.val();
    })
    .catch((err) => {
      console.log('database error');
      console.log(err);
    });
};

export const fetchStorageList = () => {
  const driveRef = firebaseCore.storage.ref();
  driveRef.listAll()
    .then((res) => {
      const list = {
        folders: res.prefixes,
        files: res.items,
      };
      store.dispatch('updateStorageList', list);

      // get the files' metadata
      list.files.forEach((file) => {
        // Create a reference to the file whose metadata we want to retrieve
        const forestRef = firebaseCore.storage.ref(file.location.path);
        // Get metadata properties
        forestRef.getMetadata().then((metadata) => {
          const payload = {};
          payload.path = file.location.path;
          payload.metadata = metadata;
          store.dispatch('updateFileInfo', payload);
        }).catch((error) => {
          // Uh-oh, an error occurred!
          console.log(error);
        });
      });
    })
    .catch((err) => {
      console.log('storage error');
      console.log(err);
    });
};

export const init = () => {
  console.log('firebase init');
  firebaseCore.auth.signInAnonymously().catch((error) => {
    // Handle Errors here.
    console.log(error);
    const err = {
      errCode: error.code,
      errMessage: error.message,
    };
    store.dispatch('updateErr', err);
  });
  firebaseCore.auth.onAuthStateChanged((user) => {
    if (user) {
      // User is signed in.
      store.dispatch('signedIn', user);
      console.log(`user is signed in. (uid: ${user.uid})`);

      // link to database
      // linktoDB(user.uid);

      // link to storage
      fetchStorageList();
    }
    else {
      console.log('user is signed out.');
      // User is signed out.
      // ...
    }
    // ...
  });
};


// upload file to firebase
export const uploadFile = (file) => {
  console.log(`upload file: ${file.name}`);
  const pathname = file.name;
  const storageRef = firebaseCore.storage.ref(pathname);
  const task = storageRef.put(file);
  task.on(
    'state_changed',
    (snapshot) => {
      const percentage = snapshot.bytesTransferred / snapshot.totalBytes * 100;
      console.log(`progress: ${percentage}%`);
    },
    (err) => {
      alert(err);
    },
    () => {
      alert('上傳成功');
      // update the list
      fetchStorageList();
    },
  );
};
